var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"video-quantity-confirm"},[_c('p',{staticClass:"current-video-quantity",domProps:{"innerHTML":_vm._s(_vm.$t('videoQuantityConfirm.currentQuantity', { quantity: _vm.currentQuantity }))}}),_vm._v(" "),_c('p',{staticClass:"sub-title"},[_vm._v("\n        "+_vm._s(_vm.$t('videoQuantityConfirm.subTitle'))+"\n    ")]),_vm._v(" "),_c('p',{staticClass:"plan-video-quantity",domProps:{"innerHTML":_vm._s(_vm.$t('videoQuantityConfirm.planQuantity', {
        quantity: _vm.planQuantity,
        plan: _vm.planTitle
    }))}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3e38a04e","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/videoQuantityConfirm.vue
// module id = null
// module chunks = 